import { debounce } from 'lodash';
import Helpers from './helpers';
import UmbracoAutomation from './umbraco-automation';
import FormHelpers from './form-helpers';

export default class SuggestedSearch {
	constructor({ elements }) {
		elements.forEach((el) => {
			const searchInputField = el.querySelector('.search-input-element');
			const suggestionsContainer = el.querySelector('.suggestions');
			const suggestedSearchContainer = el.querySelector('.suggested-search__container');
			if (el.querySelector(`.submit-search-btn`)) {
				el.querySelector(`.submit-search-btn`).setAttribute('disabled', true);
			}
			if (suggestionsContainer && searchInputField && suggestedSearchContainer) {
				searchInputField.addEventListener(
					'keyup',
					debounce((event) => {
						SuggestedSearch.handleSuggestions(
							event,
							el,
							suggestionsContainer,
							searchInputField,
							suggestedSearchContainer
						);
					}, 350)
				);
			}
			document.addEventListener('click', () => {
				SuggestedSearch.hideSuggestionsContainer(
					suggestionsContainer,
					searchInputField,
					suggestedSearchContainer
				);
			});
		});
	}

	static getResults(el, searchInput, suggestionsContainer, searchInputField) {
		const apiUrl = el.dataset?.apiUrl;
		const apiBase = '/umbraco/api/';
		fetch(`${apiBase}${apiUrl}?query=${searchInput}`, {
			headers: { 'Content-Type': 'application/json', Culture: document.documentElement.lang },
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error();
				}
				return response.json();
			})
			.then((results) => {
				if (results && results.length > 0) {
					results.map((result) => {
						if (result && result.name != null) {
							SuggestedSearch.renderSuggestion(
								el,
								result,
								searchInput,
								suggestionsContainer,
								searchInputField
							);
						}
						return result;
					});
				} else {
					SuggestedSearch.errorHandling('noResults', suggestionsContainer);
				}
			})
			.catch(() => {
				SuggestedSearch.errorHandling('serverError', suggestionsContainer);
			});
	}

	static errorHandling(errorType, suggestionsContainer) {
		const container = suggestionsContainer;
		let errorText = '';
		switch (errorType) {
			case 'noResults':
				errorText = 'Unfortunately no results were found... Try other search terms.';
				break;
			case 'serverError':
				errorText = 'Oops, something went wrong, no items could be found.';
				break;
			case 'inputTooShort':
				errorText = 'Continue typing to get suggestions...';
				break;
			default:
				errorText = '';
		}
		container.innerHTML = `<p class="text--short text--s padding--m no-margin--bottom">${errorText}</p>`;
	}

	static handleSuggestions(
		e,
		el,
		suggestionsContainer,
		searchInputField,
		suggestedSearchContainer
	) {
		const searchInput = e.target.value;
		if (searchInput && searchInput.length >= 0) {
			SuggestedSearch.showSuggestionsContainer(
				suggestionsContainer,
				searchInputField,
				suggestedSearchContainer
			);
		} else {
			SuggestedSearch.hideSuggestionsContainer(
				suggestionsContainer,
				searchInputField,
				suggestedSearchContainer
			);
		}
		if (searchInput.length >= 0 && searchInput.length <= 3) {
			SuggestedSearch.errorHandling('inputTooShort', suggestionsContainer);
		} else {
			SuggestedSearch.getResults(el, searchInput, suggestionsContainer, searchInputField);
			SuggestedSearch.errorHandling('', suggestionsContainer);
		}
	}

	static hideSuggestionsContainer(
		suggestionsContainer,
		searchInputField,
		suggestedSearchContainer
	) {
		suggestionsContainer.classList.add('hide');
		searchInputField.classList.remove('input__active');
		suggestedSearchContainer.classList.remove('suggested-search__container--active');
	}

	static showSuggestionsContainer(
		suggestionsContainer,
		searchInputField,
		suggestedSearchContainer
	) {
		suggestionsContainer.classList.remove('hide');
		searchInputField.classList.add('input__active');
		suggestedSearchContainer.classList.add('suggested-search__container--active');
	}

	static highlightMatchesInString(suggestion, query) {
		let completedString = suggestion;
		query.forEach((element) => {
			const regex = Helpers.createRegexExpr(element);
			if (!suggestion.match(regex)) {
				return;
			}
			const matchStartPosition = suggestion.match(regex).index;
			const matchEndPosition = matchStartPosition + suggestion.match(regex)[0].toString().length;
			const originalTextFoundByRegex = suggestion.substring(matchStartPosition, matchEndPosition);
			completedString = completedString.replace(
				regex,
				`<mark class="suggestion-bold">${originalTextFoundByRegex}</mark>`
			);
		});
		return completedString;
	}

	static renderSuggestion(el, result, searchInput, suggestionsContainer, searchInputField) {
		const suggestionElement = document.createElement('div');
		suggestionElement.classList.add('suggestion');
		const query = searchInput.split(' ');
		const suggestionName = result.name;
		if (suggestionElement) {
			query.forEach((element) => {
				if (element === ' ' || element === '') {
					return;
				}
				const regex = Helpers.createRegexExpr(element);
				if (!suggestionName.match(regex)) {
					suggestionElement.innerHTML = suggestionName;
				} else {
					suggestionElement.innerHTML = SuggestedSearch.highlightMatchesInString(
						suggestionName,
						query
					);
				}
			});
			suggestionsContainer.appendChild(suggestionElement);
			SuggestedSearch.handleSelectedResult(el, suggestionElement, result, searchInputField);
		}
	}

	static handleSelectedResult(el, suggestionElement, result, searchInputField) {
		const searchField = searchInputField;
		suggestionElement.addEventListener('click', () => {
			if (el.dataset.recommendedProjectTemplates) {
				FormHelpers.setRecommendedProjectTemplates(
					searchField,
					result,
					el.dataset.index,
					el.dataset.id
				);
			} else {
				searchField.value = result.name;
				UmbracoAutomation.handleSearch(el, result.key);
			}
		});
	}
}
